import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import { forwardRef } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import classNames from 'classnames';
import noop from 'lodash/fp/noop';
const SmoothScrollbars = forwardRef((componentProps, ref) => {
    const { slideIn = false, largeTrack = false, trackOffset = false, className = '', onScroll = noop, tagName = 'div', autoHeight = false, autoHeightMin = 0, autoHeightMax = 200, children, } = componentProps;
    const wrapperClassNames = classNames(className, slideIn && 'scrollbar-fly-in', 'smooth-scrollbar-wrapper');
    const renderTrackVerticalNames = classNames('scrollbar-track-vertical', largeTrack && 'scrollbar-track-size-large', trackOffset && 'scrollbar-track-offset');
    const renderThumbVerticalNames = classNames('scrollbar-thumb-vertical', largeTrack && 'scrollbar-thumb-size-large');
    const renderTrackHorizontalNames = classNames('scrollbar-track-horizontal', largeTrack && 'scrollbar-track-size-large', trackOffset && 'scrollbar-track-offset');
    const renderThumbHorizontalNames = classNames('scrollbar-thumb-horizontal', largeTrack && 'scrollbar-thumb-size-large');
    return (_jsx(Scrollbars, Object.assign({ ref: ref, tagName: tagName, onScroll: onScroll, className: wrapperClassNames, hideTracksWhenNotNeeded: true, autoHeight: autoHeight, autoHeightMin: autoHeightMin, autoHeightMax: autoHeightMax, renderView: props => {
            return _jsx("div", Object.assign({}, props, { className: 'scrollbar-view' }));
        }, renderTrackVertical: props => {
            return _jsx("div", Object.assign({}, props, { className: renderTrackVerticalNames }));
        }, renderThumbVertical: props => {
            return _jsx("div", Object.assign({}, props, { className: renderThumbVerticalNames }));
        }, renderTrackHorizontal: props => {
            return _jsx("div", Object.assign({}, props, { className: renderTrackHorizontalNames }));
        }, renderThumbHorizontal: props => {
            return _jsx("div", Object.assign({}, props, { className: renderThumbHorizontalNames }));
        } }, { children: children })));
});
export default SmoothScrollbars;
